__turbopack_context__.v({
  "card": "styles-module___-xRCW__card",
  "subtitle-animated": "styles-module___-xRCW__subtitle-animated",
  "view": "styles-module___-xRCW__view",
  "view-subtitle": "styles-module___-xRCW__view-subtitle",
});
